export const modalVariants = {
    hidden: {opacity: 0, scale: 1},
    visible: {opacity: 1, scale: 1},
};